import React from 'react';
import { 
  Markup,
  Clock
} from '../components';
import colorBar from '../styles/icons/rainbow.png';

/**
 * Footer
 */
export default class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      text: "This is footer.",
      online: true
    }
  }

  componentDidMount() {
    this.interval = setInterval(
      () => this.setState({ online: window.navigator.onLine }), 
      1000
    )
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return(
      <div 
        className="text-center hidden-print" 
        style={{
          background: `url(${colorBar}) top repeat-x`, 
          paddingTop: '0.5em'
        }}
      >
        <Markup>{this.props.footer}</Markup>
        {process.env.NODE_ENV === 'development' &&
          (<small>This is running in <b>development</b> environment.</small>)
        }
        { !this.state.online && (<b><Clock /> 掉线.</b>) }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Footer.js